import { Skeleton as SkeletonPrimitive } from '@/components/ui/skeleton'

const MEMBER_COLS = 5
const INDICATOR_ROWS = 12

const MEMBER_KEYS = Array.from({ length: MEMBER_COLS }, (_, i) => `member-${i}`)
const ROW_KEYS = Array.from({ length: INDICATOR_ROWS }, (_, i) => `row-${i}`)
const CELL_KEYS = Array.from({ length: MEMBER_COLS }, (_, i) => `cell-${i}`)

export function BoardPending() {
  return (
    <div className="mx-auto flex h-full min-h-0 w-full max-w-7xl flex-col gap-4 px-4 py-8 sm:px-6 lg:px-8">
      {/* Header — matches the real board's section header */}
      <div className="flex shrink-0 items-center justify-between gap-3">
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-3">
            <SkeletonPrimitive className="size-10 rounded-xl" />
            <SkeletonPrimitive className="h-7 w-32" />
          </div>
          <SkeletonPrimitive className="h-4 w-80" />
        </div>
      </div>

      {/* Board card — same scroll container as the real board: height-constrained,
          internally scrolling, with the vertical scrollbar gutter reserved. */}
      <div className="bg-card min-h-0 w-full overflow-auto rounded-xl border pr-3 pb-3 [scrollbar-gutter:stable]">
        <div className="mx-auto w-max">
          {/* Header row: corner cell + member columns + trailing spacer (mirrors the table's centering) */}
          <div className="flex">
            <div className="h-16 w-[208px] shrink-0" />
            {MEMBER_KEYS.map((key) => (
              <div key={key} className="flex h-16 w-14 shrink-0 flex-col items-center justify-center gap-1 p-px pt-2.5">
                <SkeletonPrimitive className="size-8 rounded-md" />
                <SkeletonPrimitive className="h-2.5 w-10" />
              </div>
            ))}
            <div className="w-[208px] shrink-0" />
          </div>

          {/* Body rows: indicator name + score cells + trailing spacer */}
          {ROW_KEYS.map((rowKey) => (
            <div key={rowKey} className="flex">
              <div className="flex h-12 w-[208px] shrink-0 items-center gap-3 px-3">
                <SkeletonPrimitive className="size-2.5 shrink-0 rounded-full" />
                <SkeletonPrimitive className="h-3.5 w-32" />
              </div>
              {CELL_KEYS.map((cellKey) => (
                <div key={cellKey} className="flex h-12 w-14 shrink-0 items-center justify-center">
                  <SkeletonPrimitive className="size-11 rounded-xl" />
                </div>
              ))}
              <div className="w-[208px] shrink-0" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
